
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CredentialsStateService {
  // Se quiser manter BehaviorSubject para ambos
  private credentialCreatedSource = new BehaviorSubject<boolean>(false);
  private credentialCancelledSource = new BehaviorSubject<boolean>(false);
  
  // Compartilhamento de número de credencial para consulta
  private credentialNumberSource = new BehaviorSubject<string>('');
  public credentialNumber$ = this.credentialNumberSource.asObservable();

  credentialCreated$ = this.credentialCreatedSource.asObservable();
  credentialCancelled$ = this.credentialCancelledSource.asObservable();

  notifyCredentialCreated(): void {
    this.credentialCreatedSource.next(true);
  }

  notifyCredentialCancelled(): void {
    this.credentialCancelledSource.next(true);
  }

  setCredentialNumber(credentialNumber: string): void {
    this.credentialNumberSource.next(credentialNumber);
  }

  getCredentialNumber(): string {
    return this.credentialNumberSource.value;
  }

  clearCredentialNumber(): void {
    this.credentialNumberSource.next('');
  }

  reset(): void {
    this.credentialCreatedSource.next(false);
    this.credentialCancelledSource.next(false);
    this.clearCredentialNumber();
  }
}
